import { VideoTracking } from "_fil_local_addon/camc-cms-base/index";

class youkuHandler {
    constructor(obj_id, orbit_instance = null) {
        this.clientId = "4fa8c817b479c1e2";
        this.objId = obj_id;
        this.orbitInstance = orbit_instance;
        this.$root = $(`#${obj_id}`);
        this.instanceId = this.objId.split("youku-")[1];
        this.videoId = this.$root.attr("videoId");
        this.$thumbnail = this.$root.find(".youku__thumbnail");
        this.$modal = null;
        this.player = null;
        this.tempScrollTop = 0;
    }

    setup() {
        const apiUrl = `https://api.youku.com/videos/show.json?client_id=${this.clientId}&video_id=${this.videoId}`;
        fetch(apiUrl)
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    this._initThumbnail(data.bigThumbnail);
                    this.$root.find(".youku__item").attr("data-title", data.title);
                    this.$root.find(".youku__item").attr("data-url", apiUrl);
                    this.$root.find(".youku__item").attr("data-video-id", this.videoId);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    _generatePlayer() {
        this.player = new YKU.Player(`youkuplayer-${this.instanceId}`, {
            styleid: "0",
            client_id: this.clientId,
            vid: this.videoId,
            newPlayer: true,
            autoplay: true,
            events: {
                onPlayerReady: () => {
                    this._resizeMediaBlockYouku();
                    window.addEventListener("resize", () => {
                        this._resizeMediaBlockYouku();
                    });
                },
            },
        });

        return this.player;
    }

    _initThumbnail(thumbnail) {
        if (thumbnail) {
            this.$thumbnail.attr("src", thumbnail);
            this.$thumbnail.on("load", () => {
                this.$root.find(".youku__loader").remove();
                this.$root.find(".youku__item--error").remove();
                this.$root.find(".youku__item").show();
            });
            this.$root.find(".youku__item").on("click", () => {
                this._showPlayer();
            });
        } else {
            console.error("Thumbnail not found");
            this.$root.find(".youku__loader").hide();
            this.$root.find(".youku__item--error").show();
            this.$root.find(".youku__item--error").on("click", () => {
                this.$root.find(".youku__loader").show();
                this.$root.find(".youku__item--error").hide();
                this.setup();
            });
        }
    }

    _showPlayer() {
        const modalTemplate = `
            <div class="reveal-overlay reveal-overlay--youku" style="display: block; z-index: 1011;" id="youku-modal-${this.instanceId}">
                <div class="fil-modal--youku fil-modal reveal icon" style="display: block">
                    <div class="youkuplayer-container">
                        <div id='youkuplayer-${this.instanceId}' class="youkuplayer-ground"></div>
                    </div>
                    <button class="modal__exit_amc" style="overflow: visible;">
                        <span class="fil-icon fil-icon-cross-light"></span>
                    </button>
                </div>
            </div>`;
        this.$modal = $(modalTemplate);

        if (this.orbitInstance) {
            this.$root.closest(".camc-text-media-block-carousel-wrapper").append(this.$modal);
            this.orbitInstance.options.videoIsPlaying = true;
            this.orbitInstance.timer.pause();
        } else {
            this.$root.closest(".fil-media-grid").append(this.$modal);
        }

        this.$modal.find(".modal__exit_amc").on("click", () => {
            this._closePlayer();
        });

        this._disableScroll();
        this._generatePlayer();
    }

    _closePlayer() {
        if (this.$modal && this.$modal.length) {
            this.$modal.remove();
            this._enableScroll(this.tempScrollTop);
        }
        if (this.orbitInstance) {
            this.orbitInstance.options.videoIsPlaying = false;
            this.orbitInstance.timer.start();
        }
    }

    _resizeMediaBlockYouku() {
        const $player = $(`#youkuplayer-${this.instanceId}`);
        const cellWidth = $player.closest(".youkuplayer-container").width();
        const height = cellWidth * 0.5625; // 16:9 aspect ratio
        $player.css({ height, width: cellWidth });
    }

    _disableScroll(scrollTop) {
        scrollTop = scrollTop || $(window).scrollTop();
        if ($(document).height() > $(window).height()) {
            $("html").css("top", -scrollTop);
            this.tempScrollTop = parseInt(-scrollTop, 10);
        }
        $("html").addClass("zf-has-scroll is-reveal-open");
    }

    _enableScroll(scrollTop) {
        $("html").removeClass("zf-has-scroll is-reveal-open");
        if ($(document).height() > $(window).height()) {
            $("html").css("top", "");
            $(window).scrollTop(-scrollTop);
        }
    }
}

export default youkuHandler;
